export class RequestError extends Error {
  statusCode: number;
  error: string;
  msg: string;
  constructor(statusCode: number, error: string, message: string) {
    super(message);
    this.statusCode = statusCode;
    this.error = error;
    this.msg = message;
  }
}
export interface IResponseData<T> {
  data: T;
  statusCode?: number;
  message: string;
  success?: boolean;
}

export interface IResponseError {
  error: string;
  message: string;
  statusCode: number;
  success: boolean;
  timestamp: string;
}
export interface IPaginationResponse {
  total: number;
  totalPage: number;
  currentPage: number;
  limit: number;
}

export interface IListResponse<T> extends IPaginationResponse {
  totalCount?: {
    viewsCount: number;
    entriesCount: number;
    unitsSoldCount: number;
  };
  availableUnitCount?: number;
  totalUnitCount?: number;
  soldUnitCount?: number;
  reservedUnitCount?: number;
  notReleasedUnitCount?: number;
  items?: T[];
  submissionLogs?: T[];
  score?: number;
}

export interface IListResponseNotifications<T> {
  items: T[];
  total: number;
  totalPage: number;
  currentPage: number;
  limit: number;
  unreadCount: number;
}

export type ListResponseData<T> = IResponseData<IListResponse<T>>;

export type ListResponseNotificationsData<T> = IResponseData<IListResponseNotifications<T>>;

export interface IRequestPagination {
  limit: number;
  page: number;
}

export interface QueryObject {
  filter: Record<string, string>[];
  sort: Record<string, "desc" | "asc" | "DESC" | "ASC">;
  search: Record<string, string>;
  projectId?: string;
}

export interface IRequestParams {
  query?: QueryObject;
  pagination?: IRequestPagination;
}
export interface IRequestArgs {
  queryParams?: IRequestParams;
  data?: Record<string, any>;
  projectId?: string;
  id?: string;
}

export interface IUpdateResult {
  raw: any;
  affected?: number;
  generatedMaps: Record<string, any>[];
}
